/**
 * Formatting helpers for the sync pages.
 *
 * Kept apart from syncUi.tsx because a file that exports both components and plain
 * functions breaks Vite's fast refresh.
 */

export const formatDateTime = (value: string | null) =>
    value ? new Date(value).toLocaleString() : '—';

export const formatNumber = (value: number | null | undefined) =>
    value === null || value === undefined ? '—' : value.toLocaleString();

/** Rough "3 minutes ago", which is what you actually want when judging freshness. */
export const formatRelative = (value: string | null): string => {
    if (!value) return 'never';
    const seconds = Math.floor((Date.now() - new Date(value).getTime()) / 1000);
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days === 1 ? '' : 's'} ago`;
};

export const formatDuration = (ms: number | null) => {
    if (ms === null) return '—';
    if (ms < 1000) return `${ms} ms`;
    const seconds = Math.round(ms / 100) / 10;
    return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`;
};
